import React from 'react';

import { Heading } from '@depop/web-thrift-ui/Typography';
import { Carousel } from '@depop/web-ui-kit/Carousel';
import { useTranslations } from 'next-intl';

import { BagDeleteSoldOutItems } from '../BagDeleteSoldOutItems';

import styles from './styles.module.css';

import { SellingItemImage } from '@/components/SellingItemImage';
import {
  type DetailedBagProduct,
  type DetailedBagProducts,
} from '@/modules/bag/aliases';
import {
  filterRequiredPictures,
  getNearestSizePictureFormat,
} from '@/modules/pictures/helpers';
import { type LegacyProductStatus } from '@/modules/product/types';

type SoldOutProps = {
  products: DetailedBagProducts;
  sellerId: number;
};

const itemsPerSlide = {
  xs: 3,
  sm: 3,
  md: 4,
  lg: 4,
  xl: 3,
};

function getProductToDisplay(product: DetailedBagProduct) {
  const { pictures, status } = product;
  if (pictures) {
    return (
      <div className={styles.soldOutImageContainer}>
        <SellingItemImage
          className={styles.sellingItemImage}
          src={
            getNearestSizePictureFormat(
              filterRequiredPictures(pictures[0]),
              120
            )?.url
          }
          status={status as LegacyProductStatus}
        />
      </div>
    );
  }
  return null;
}

function BagSoldOutItems({ products, sellerId }: SoldOutProps) {
  const t = useTranslations('bag');

  return (
    <>
      <div className={styles.headingContainer}>
        <Heading variant="sm" className={styles.heading}>
          {t('Bag.SoldOut.Title')}
        </Heading>
      </div>
      <Carousel
        itemsPerSlide={itemsPerSlide}
        items={products.map(getProductToDisplay)}
      />
      <BagDeleteSoldOutItems products={products} sellerId={sellerId} />
    </>
  );
}

export { BagSoldOutItems };
